import { useContext } from "react";
import { ModalRouteContext } from "contexts/modal-route-context";

export const useModalParams = <T extends Record<string, string>>() =>
  useContext(ModalRouteContext)?.params as T;
